// extracted by mini-css-extract-plugin
export var button = "_nm-2";
export var card = "_nm-0";
export var closeButtonContainer = "_nm-3";
export var iconContainer = "_nm-1";